import {DisplayListener, Payment, PaymentTerminal} from "@variocube/app-api";
import {CurrentPayment, InitiatePaymentError} from "./payment";

export class MockPaymentTerminal implements PaymentTerminal {

    private currentPayment?: CurrentPayment;

    approvePayment() {
        this.currentPayment?.displayListener(["Payment approved."]);
        this.currentPayment?.resolve({
            receiptText: "Mock payment approved",
            merchantReceiptText: "Mock merchant receipt"
        });
    }

    denyPayment() {
        this.currentPayment?.displayListener(["Payment denied."]);
        this.currentPayment?.reject(new InitiatePaymentError("Payment denied", false));
        this.currentPayment = undefined;
    }

    cancelPayment(): Promise<void> {
        this.currentPayment = undefined;
        return Promise.resolve();
    }

    confirmPayment() {
        this.currentPayment = undefined;
        return Promise.resolve();
    }

    initiatePayment(amount: number, currency: string, language: string, displayListener: DisplayListener) {
        if (this.currentPayment) {
            throw new InitiatePaymentError("There is already a payment in progress", true);
        }

        displayListener([
            "Mock payment in progress.",
            "Approve or deny through mock tools."
        ]);

        return new Promise<Payment>((resolve, reject) => {
            this.currentPayment = {
                amount, currency, displayListener, resolve, reject
            };
        });
    }

}
